<template>
   <div>
       <router-link :to="{ name: 'bank-terminal-transactions', query: {branchName: data.branchName, paymentDate: data.paymentDate}}" class="btn dealers_btn ">
        {{$t('text.clickButtons.details')}}
       </router-link>
   </div>
</template>

<script>
import configObject from "@/config";
import Jquery from "jquery";
let $ = Jquery;

export default {
  data() {
    return {
      data: {},
    };
  },
  mounted() {
      
  },
  methods: {
      
  },
};
</script>